import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Link } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';

const SubjectWiseFreeSlotCard = ({ setModalState, dispatchParams }) => {
  const subjectWiseFreeSlotCardsLoading = useSelector((state) => state.crd.subjectWiseFreeSlotCards.loading);
  const subjectWiseFreeSlotCards = useSelector((state) => state.crd.subjectWiseFreeSlotCards.data);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 16,
  });

  const paginatedData = useMemo(() => {
    const total = subjectWiseFreeSlotCards?.length ?? 0;
    const paginationMul = pagination?.page * pagination?.limit;
    const limit = pagination?.limit;

    if (!total) return [];
    return subjectWiseFreeSlotCards?.slice(paginationMul - limit, paginationMul);
  }, [subjectWiseFreeSlotCards, pagination]);

  return (
    <Stack gap={2}>
      <Grid container spacing={1}>
        {subjectWiseFreeSlotCardsLoading ? (
          Array.from({ length: pagination?.limit }).map((_, i) => (
            <Grid item xs={12} sm={6} md={3} lg={4} xl={3} key={i}>
              <Skeleton sx={{ minHeight: 170 }} />
            </Grid>
          ))
        ) : paginatedData?.length ? (
          paginatedData?.map((v, i) => (
            <Grid item xs={12} sm={6} md={3} lg={4} xl={3} key={i}>
              <Card
                sx={{
                  width: '100%',
                  borderRadius: 2,
                  border: '1.5px solid #1976d2',
                  backgroundColor: '#F9FAFB80',
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    pb: '16px !important',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{v?.subject_name}</Typography>

                    <Link
                      to={{
                        pathname: `card-tutor-info`,
                        search: `?${new URLSearchParams({ ...dispatchParams, type: 'subject_wise', subject: v?.subject_id })}`,
                      }}
                    >
                      <IconButton size="small">
                        <InfoOutlinedIcon sx={{ width: 20, height: 20, color: '#6B7280' }} />
                      </IconButton>
                    </Link>
                  </Box>

                  <Typography sx={{ fontSize: 12, color: '#6B7280' }}>Free Slots</Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 24,
                        fontWeight: 700,
                        color: '#1E6BB8',
                      }}
                    >
                      {v?.free_slots}/{v?.total_slots}
                    </Typography>

                    <IconButton
                      size="small"
                      onClick={() => setModalState({ actionKey: 'Previous Month History', row: v })}
                    >
                      <VisibilityOutlinedIcon sx={{ width: 20, height: 20, color: '#1E6BB8' }} />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Stack sx={{ alignItems: 'center', justifyContent: 'center' }} width={'100%'}>
            <NoDataFound />
          </Stack>
        )}
      </Grid>
      <Pagination
        disabled={subjectWiseFreeSlotCardsLoading}
        sx={{ alignSelf: 'flex-end' }}
        count={subjectWiseFreeSlotCards?.length ? Math.ceil(subjectWiseFreeSlotCards?.length / pagination?.limit) : 0}
        page={pagination.page}
        onChange={(_, v) => {
          setPagination((prev) => ({ ...prev, page: v }));
        }}
      />
    </Stack>
  );
};
export default React.memo(SubjectWiseFreeSlotCard);
